import { usePropertyBuilder } from "@/components/views/config/helpers";
import { useSteamWorkshop } from "@/components/views/mods/steam_workshop";
import type { NecesseProfileNamespace } from "@/graphql";
import { useServiceStore } from "@/store/service";
import { faPuzzlePiece } from "@fortawesome/pro-solid-svg-icons";
import { computed } from "vue";
import { commonMenuItems } from "./common";
import defaultProfile, { asyncRoute } from "./default";
import { type ConfigSection, type GameProfile, type Menu, MenuItem, type ProfileCtx } from "./types";

const createMenu = (ctx: ProfileCtx): Menu => {
  const menu = defaultProfile(ctx).menu;
  menu[0].items.push(commonMenuItems.logs);
  menu[0].items.push(commonMenuItems.console);
  menu[0].items.push(
    new MenuItem(
      "mods",
      faPuzzlePiece,
      asyncRoute(() => import("../components/views/config/necesse/Mods.vue")),
      [
        {
          route: "manage",
          component: asyncRoute(() => import("../components/views/mods/manage/ModsManage.vue")),
        },
      ],
    ),
  );
  return menu;
};

export function useMods() {
  const service = useServiceStore();
  const { buildProperty } = usePropertyBuilder();
  const { buildConfig } = usePropertyBuilder();

  const profile = computed(() => service.ctx.profile as NecesseProfileNamespace | undefined);
  const selectedWorkshopItems = computed(() => profile.value?.selectedWorkshopItems ?? []);
  const subscribedFileIds = buildProperty<Array<string>>("virtual", "mods", []);
  const subscribedCollectionIds = buildConfig<Array<string>>("subscribedCollectionIds", []);
  return useSteamWorkshop(selectedWorkshopItems, subscribedFileIds, subscribedCollectionIds);
}

const configSections: ConfigSection[] = [{ component: "ConfSection", props: { name: "general" } }];

export default (_ctx: ProfileCtx): Partial<GameProfile> => ({
  configSections,
  useMods,
  menu: createMenu(_ctx),
});
